/**
 * 悬赏榜相关接口
 */
import http, { BASE_NAME, UPLOAD_URL } from './index.js';

/**
 * 获得地区树
 */
export async function allAreaTree(value) {
  try {
    const data = await http.get(`${BASE_NAME}/system/area/tree`, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 * 文件上传
 */
export async function fileUpload(value) {
  try {
    const data = await http.post(UPLOAD_URL, value);

    return data;
  } catch (error) {
    console.error(error);
  }
}

/**
 *  根据字典类型查询字典数据信息
 */
export async function getDictDataApi(value) {
  try {
    const data = await http.get(`${BASE_NAME}/system/dict-data/type`, {
      params: value,
    });

    return data;
  } catch (error) {
    console.error(error);
  }
}
